import React from 'react';
import { Flag, Handshake } from 'lucide-react';

interface ChessControlsProps {
  onResign: () => void;
  onOfferDraw: () => void;
  disabled?: boolean;
}

export function ChessControls({ onResign, onOfferDraw, disabled }: ChessControlsProps) {
  return (
    <div className="bg-gray-800 p-4 rounded-lg space-y-4">
      <h3 className="text-lg font-bold text-white mb-4">Game Controls</h3>
      
      <div className="grid grid-cols-2 gap-4">
        <button
          onClick={onResign}
          disabled={disabled}
          className="flex items-center justify-center gap-2 px-4 py-2 bg-red-500/10 text-red-400 rounded-lg hover:bg-red-500/20 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Flag className="w-4 h-4" />
          Resign
        </button>
        
        <button
          onClick={onOfferDraw}
          disabled={disabled}
          className="flex items-center justify-center gap-2 px-4 py-2 bg-blue-500/10 text-blue-400 rounded-lg hover:bg-blue-500/20 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Handshake className="w-4 h-4" />
          Offer Draw
        </button>
      </div>
    </div>
  );
}